var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListAltSolid = function SvgListAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.281 5.281 7 8.563 5.719 7.28 4.28 8.72l2 2 .719.687.719-.687 4-4ZM15 7v2h13V7Zm-4.719 6.281L7 16.562l-1.281-1.28-1.438 1.437 2 2 .719.687.719-.687 4-4ZM15 15v2h13v-2Zm-4.719 6.281L7 24.563 5.719 23.28 4.28 24.72l2 2 .719.687.719-.687 4-4ZM15 23v2h13v-2Z"
  })));
};
export default SvgListAltSolid;